{
  "edit": {
    "name": "Название *"
  },
  "stateEdit": {
    "name": "Название *",
    "namePlaceholder": "Новый, Старый, Поврежденный, Включенный…",
    "description": "Описание (что меняется в этом состоянии; этот блок попадёт в промпт референса)"
  },
  "promptPreview": {
    "title": "Промпт референса",
    "stateSuffix": " · состояние «{{name}}»",
    "building": "Строю промпт…",
    "failed": "Не удалось: {{error}}",
    "systemPrompt": "Системный промпт",
    "userPrompt": "Пользовательский промпт"
  },
  "references": {
    "title": "Версии референса",
    "base": " · базовый",
    "stateSuffix": " · состояние «{{name}}»",
    "hint": "Можно выбрать несколько файлов. Загрузите свою картинку или выберите активную из сгенерированных ранее.",
    "upload": "Загрузить файл",
    "loading": "Загружаем версии…",
    "empty": "Ещё нет версий. Сгенерируйте референс или загрузите файл.",
    "noPreview": "Нет превью",
    "active": "Активна",
    "uploaded": "Загружено",
    "generated": "Сгенерировано",
    "cleared": "Очищено",
    "correct": "Корректировать",
    "makeActive": "Сделать активной",
    "delete": "Удалить",
    "deleteConfirm": "Удалить эту версию референса?"
  }
}
